// @flow

import * as React from 'react';

import { ProfileCardResponsive } from '@ta/social.cards';
import type { SuggestedFollowee } from '@ta/social.member-types';

type Props = {
  suggestedFollowees: SuggestedFollowee[],
};

const SuggestedTripAdvisorMembersSingleSection = (props: Props) => (
  <React.Fragment>
    {props.suggestedFollowees.map(followee =>
      followee.userProfile ? (
        <ProfileCardResponsive
          key={followee.userProfile.userId}
          profile={followee.userProfile}
          memberInfo={followee.info}
        />
      ) : null,
    )}
  </React.Fragment>
);

export default SuggestedTripAdvisorMembersSingleSection;
